module.exports = __webpack_public_path__ + "static/media/made-in-usa.5cd00673.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/categories/made-in-usa.svg
 ** module id = 449
 ** module chunks = 0
 **/